import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { OptionItem } from '../../../../model/optionItem';
import { UntypedFormControl } from "@angular/forms";
import { debounceTime, switchMap, startWith } from "rxjs/operators";
import { of } from "rxjs";

export class ColumnFilterInfo {
  columnName: string;
  values: any[];
  active: boolean;

  constructor(columnName: string, values: any[]) {
    this.columnName = columnName;
    this.values = values;
  }
}

class ViewModel {
  items: OptionItem[];
}

@Component({
    selector: 'app-column-filter',
    templateUrl: './column-filter.component.html',
    styleUrls: ['./column-filter.component.css'],
    standalone: false
})
export class ColumnFilterComponent implements OnInit, OnChanges {

  @Input() columnName: string;
  @Input() values: any[];
  @Input() columnFilterValues: any[];
  @Output() applyFilter = new EventEmitter<ColumnFilterInfo>();
  @Output() clearFilter = new EventEmitter<string>();
  @Output() closeFilter = new EventEmitter();

  viewModel = new ViewModel();
  search = new UntypedFormControl();
  selectedSet = new Set<any>();

  constructor() { }

  @ViewChild('resizeContainer') resizeContainer: ElementRef;
  height: number = 330; // Default height
  width: number = 220;
  private resizeObserver: ResizeObserver;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        this.height = Math.round(entry.contentRect.height);
        this.width = Math.round(entry.contentRect.width);
      }
    });
    if (this.resizeContainer) {
      this.resizeObserver.observe(this.resizeContainer.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
  
  ngOnInit(): void {
    // this.refreshValues();
  }
  
  private refreshValues(): void {
    if (this.values) {
      this.selectedSet = new Set(this.columnFilterValues);
      this.viewModel.items = [];
      this.viewModel.items.push(new OptionItem(undefined, '(Select All)', true));
      const items = this.values.sort((a, b) => b > a ? -1 : 1);
      // items = items.map(x => {
      //   return this.getFilterDisplayText(x);
      // });

      // get Unique values only
      const uniqueItems: any[] = Array.from( new Set(items));

      uniqueItems.forEach( i => {
        this.viewModel.items.push( new OptionItem(i, this.getFilterDisplayText(i), true));
      });
    }
    this.search.setValue("");
  }

  private getFilterDisplayText(data: any): string {
    if (typeof data === 'string') {
      return data.length === 0 ? '(Blanks)' : data;
    }
    else {
      return String(data);
    }
  }

  ngOnChanges(changes: any): void {
    if (changes.values?.currentValue && changes.values?.currentValue !== changes.values?.previousValue) {
      this.refreshValues();
    }
  }

  onFilterItemSelected(event: any): void {
    if (event.options[0].value === undefined) {
      this.viewModel.items.forEach( i => {
        i.isSelected = event.options[0].selected;
      });
    } else {
      // automatically deselect 'All' if we chose one of the other values
      this.viewModel.items[0].isSelected = false;
    }
  }

  onApplyFilter(): void {
    const selectedValues = this.viewModel.items
      .filter(i => i.isSelected === true)
      .map(o => o.value);

    const filterInfo = new ColumnFilterInfo(this.columnName, selectedValues);
    filterInfo.active = true;
    this.applyFilter.emit(filterInfo);
  }

  onClearFilter(): void {
    this.viewModel.items.forEach( i => {
      i.isSelected = true;
    });
    this.clearFilter.emit(this.columnName);
  }

  onCloseFilter(): void {
    this.closeFilter.emit();
  }

  $search = this.search.valueChanges.pipe(
    startWith(null),
    debounceTime(200),
    switchMap((res: string) => {
      
      if (!res){ 
        if (this.viewModel.items){ 
          this.viewModel.items.forEach(item=>{
            if(this.columnFilterValues.length>0){
              item.isSelected=this.selectedSet.has(item.value);
            }else{
              item.isSelected=true;
            }
          })
          return of(this.viewModel.items);
        }
      }
      if (this.viewModel.items){
        this.viewModel.items.forEach(item=>{
          item.isSelected=false;
        })
        this.viewModel.items.filter(x => x.text.toLowerCase().indexOf(res.toLowerCase()) >= 0).forEach(itm=>{itm.isSelected=true;}) 
        this.viewModel.items[0].isSelected = false;
        return of(
          this.viewModel.items.filter(x => x.text.toLowerCase().indexOf(res.toLowerCase()) >= 0) 
        );
      }
      return of([]);
    })
  );
}
